<template>
    <section
      class="InfoBanner"
      :class="{
        'is-compact': compact,
      }"
      role="note"
      aria-label="Information"
    >
      <span class="InfoBanner__icon" aria-hidden="true" v-html="iconSvg"></span>
      <p class="InfoBanner__text"><slot>{{ text }}</slot></p>
    </section>
  </template>
  
  <script>
  export default {
    name: 'InfoBanner',
    props: {
      text: { type: String, default: '' },
      compact: { type: Boolean, default: false }, // true = the smaller version (second screenshot)
    },
    computed: {
      iconSvg () {
        // green outlined square with exclamation mark – crisp & accessible
        return `
          <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="2" width="24" height="24" rx="6" fill="none" stroke="#4aa368" stroke-width="2"/>
            <circle cx="14" cy="19.5" r="1.6" fill="#4aa368"/>
            <rect x="13" y="7" width="2" height="9" rx="1" fill="#4aa368"/>
          </svg>
        `
      }
    }
  }
  </script>
  
  <style scoped>
  /* Whole component uses Raleway on this page per your rule */
  .InfoBanner {
    font-family: 'Raleway';
  
    /* container */
    max-width: 1100px;           /* wide desktop */
    margin: 22px auto;
    padding: clamp(16px, 2.2vw, 28px) clamp(18px, 3vw, 36px);
    background: #eef6f2;         /* soft green */
    border: 1px solid #e2eee7;   /* subtle border */
    border-radius: 12px;
  
    /* layout */
    display: grid;
    grid-template-columns: 28px 1fr;
    column-gap: clamp(12px, 2vw, 18px);
    align-items: start;
  }
  
  /* smaller variant (second screenshot) */
  .InfoBanner.is-compact {
    padding: clamp(12px, 1.6vw, 20px) clamp(16px, 2.2vw, 24px);
    border-radius: 10px;
  }
  
  .InfoBanner__icon {
    line-height: 0;
    transform: translateY(2px);
  }
  
  .InfoBanner__text {
    color: #1f1f1f;
    margin: 0;
    line-height: 1.7;
    font-size: clamp(14px, 1.5vw, 16px); /* desktop matches screenshot typography */
  }
  
  /* Mobile polish */
  @media (max-width: 768px) {
    .InfoBanner {
      grid-template-columns: 24px 1fr;
      row-gap: 6px;
    }
    .InfoBanner__text {
      font-size: clamp(14px, 4.2vw, 16px);
      line-height: 1.75;
    }
  }
  </style>
  